export const SEND_INVITE_TO_CONTACT = 'SEND_INVITE_TO_CONTACT'
export const SEND_INVITE_TO_CONTACT_REQUEST = 'SEND_INVITE_TO_CONTACT_REQUEST'
export const SEND_INVITE_TO_CONTACT_SUCCESS = 'SEND_INVITE_TO_CONTACT_SUCCESS'
export const SEND_INVITE_TO_CONTACT_ERROR = 'SEND_INVITE_TO_CONTACT_ERROR'
